import { PluginType, EventType, } from '@segment/analytics-react-native';
import { CookieAwareEnrichmentPlugin } from './CookieAwareEnrichmentPlugin';
export class MetaPixelEnrichmentPlugin extends CookieAwareEnrichmentPlugin {
    type = PluginType.enrichment;
    async execute(event) {
        if (!this.isWeb) {
            return event;
        }
        const fb = await this.getTrackingData();
        const isValidEventType = event.type === EventType.TrackEvent
            || event.type === EventType.ScreenEvent;
        if (isValidEventType && fb) {
            event.context.clientIds = {
                ...event.context.clientIds,
                ...fb,
            };
        }
        return event;
    }
    async getTrackingData() {
        const data = {};
        if (!this.isWeb)
            return data;
        for (const key of ['fbc', 'fbp']) {
            const cookie = await this.getCookieValue(`_${key}`);
            if (cookie) {
                data[key] = cookie;
            }
        }
        if (!data['fbc']) {
            const fbc = this.getFbcFromUrlParams();
            if (fbc) {
                data['fbc'] = fbc;
            }
        }
        return data;
    }
    getFbcFromUrlParams() {
        const parsed = new URL(window.location.href);
        const fbclid = parsed.searchParams.get('fbclid');
        if (fbclid) {
            const subdomainIndex = window.location.hostname === 'localhost'
                ? 1
                : window.location.hostname.split('.').length - 1;
            return `fb.${subdomainIndex}.${Date.now()}.${fbclid}`;
        }
        return undefined;
    }
}
//# sourceMappingURL=MetaPixelEnrichmentPlugin.js.map